import { Table } from "soprasteria-ui-library";
import * as React from 'react';
import { Link } from 'react-router-dom';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { IPatientRefrainingFreeDentalCare } from "../../../models/IPatient";
import { PATIENT } from '../../../utils/RouteConstants';

interface IPatientsRefrainingFreeDentalCareTable {
    patients: IPatientRefrainingFreeDentalCare[] | undefined;
}

export const PatientsRefrainingFreeDentalCareTable: React.FunctionComponent<IPatientsRefrainingFreeDentalCareTable> = ({ patients }) => {

    const goToPatientLink = (text: string, patientGuidId: string) => {
        return (
            <Link to={`/${PATIENT}/${patientGuidId}`}>{text}</Link>
        )
    }

    return (
        <section>
            {
                patients ?
                    <Table hoverableRows={patients.length > 0}>
                        <thead>
                            <tr>
                                <th>Personnummer</th>
                                <th>Namn</th>
                                <th>Adress</th>
                                <th>Postnummer</th>
                                <th>Postadress</th>
                                <th>Vårdbehovsområde</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                patients.length > 0
                                    ? patients.map((patient, key) => {
                                        return (
                                            <tr className="clickable-row" key={key} >
                                                <td className="table-data-link">{goToPatientLink(formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityId), patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.name, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.address, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.zipCode, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.postAddress, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.careNeedArea, patient.patientGuidId)}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td colSpan={6}>Det finns inga patienter som avstår avgiftsfri tandvård</td></tr>
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </section>
    )
}